/**
* 日志
*/
const log = {
  
getOperationLog: "/api/getOperationLog",//查询操作日志
getLoginLog: "/api/getLoginLog",//查询登录日志
}

export default log